/**
 * @typedef {import('axios').AxiosInstance} AxiosInstance
 */

export class InvoiceService {
  /**
   * @param {AxiosInstance} axios
   */
  constructor(axios) {
    this.axios = axios;
  }

  async getInvoiceList(data, signal) {
    const result = await this.axios.post(
      "/mgr/invoices/queryInvoicesList",
      data,
      { signal }
    );
    return result.data;
  }

  async checkItemSold(data) {
    const result = await this.axios.get(
      `/mgr/invoices/checkItemSoldOrNot/${data}`
    );
    return result.data;
  }

  async replacePart(partNo, partDesc, make, model, series) {
    const params = new URLSearchParams({
      partNo,
      partDesc,
      ...(make && { make }),
      ...(model && { model }),
      ...(series && { series })
    });
    const result = await this.axios.get(
      `/mgr/invoices/replacePart?${params.toString()}`
    );
    return result.data;
  }
  async generateInvoicePdf(invoiceId) {
    const result = await this.axios.get(
      `/mgr/invoices/generateInvoicePdf/${invoiceId}`
    );
    return result.data;
  }
  async generateCreditNotesPdf(creditId) {
    const result = await this.axios.get(
      `/mgr/invoices/generateCreditNotesPdf/${creditId}`
    );
    return result.data;
  }
  async sendEmailInvoice(data) {
    const result = await this.axios.post("/mgr/invoices/sendMail/", data);
    return result.data;
  }

  async getCurrentQuote(pageNum, pageSize, search) {
    const result = await this.axios.get(
      `/mgr/invoices/getCurrentQuote?pageNum=${pageNum}&pageSize=${pageSize}&search=${search}`
    );
    return result.data;
  }

  async saveInvoicesInfo(data) {
    const result = await this.axios.get("/mgr/invoices/saveInvoicesInfo", data);
    return result.data;
  }
}
